'use strict';

import versioner from '../versioner';
import process from './process';

versioner['scmwd_after_hours'] = {
	process: process,
}

const MODULE_NAME = 'daupler.incidents.versions.scmwd';

export default MODULE_NAME;
